import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import routes from 'src/routes';
import styles from './BackToResults.module.less';

type BackToResultsProps = {
    URLSearch: string | null;
};

const BackToResults: React.FC<BackToResultsProps> = ({ URLSearch }) => {
    const searchParams = new URLSearchParams(URLSearch || '');
    searchParams.set('back', 'true');

    return <Link
        className={styles.backLink}
        to={{
            pathname: routes.productFinder,
            search: searchParams.toString(),
        }}
    >
        <FontAwesomeIcon icon={['far', 'chevron-left']} size={'xs'} className={styles.backIcon} />
        Back to results
    </Link>
};

export default BackToResults;
